export default [
    {
        path: "/compliance/deviations",
        name: "submitted-deviations",
        meta: {title: "Deviations and Accreditations", authRequired: true},
        component: () => import("../views/compliance-monitoring/SubmittedDeviations.vue"),
    },
    {
        path: "/compliance/cancelled-tenders",
        name: "cancelled-tenders",
        meta: {title: "Cancelled Tenders", authRequired: true},
        component: () => import("../views/compliance-monitoring/CancelledTenders.vue"),
    },
    {
        path: "/compliance/deviations/review",
        name: "deviation-review",
        meta: {title: "Deviation Review", authRequired: true},
        component: () => import("../views/compliance-monitoring/DeviationReview.vue"),
    },
    {
        path: "/compliance/deviations/view",
        name: "deviation-view",
        meta: {title: "View Deviation", authRequired: true},
        component: () => import("../views/compliance-monitoring/DeviationView.vue"),
    },
    {
        path: "/compliance/assessment-tools",
        name: "assessment-tools-list",
        meta: {title: "Assessment Tools", authRequired: true},
        component: () => import("../views/compliance-monitoring/AssessmentToolsList.vue"),
    },
    {
        path: "/compliance/assessment-tools/create",
        name: "create-assessment-tool",
        meta: {title: "Create Assessment Tool", authRequired: true},
        component: () => import("../views/compliance-monitoring/AssessmentToolWizard.vue"),
    },
    {
        path: "/compliance/assessment-tools/:id/view",
        name: "view-assessment-tool",
        meta: {title: "Assessment Tool Details", authRequired: true},
        component: () => import("../views/compliance-monitoring/AssessmentToolDetails.vue"),
    },
    {
        path: "/compliance/assessment-tools/:id/edit",
        name: "edit-assessment-tool",
        meta: {title: "Edit Assessment Tool", authRequired: true},
        component: () => import("../views/compliance-monitoring/AssessmentToolWizard.vue"),
    },
    // Assessment Plan Approval (workflow action_url route)
    {
        path: "/compliance/assessment-plans/approve",
        name: "compliance/assessment-plans/approve",
        meta: {title: "Assessment Plan Approval", authRequired: true},
        component: () => import("../views/compliance-monitoring/AssessmentPlanApproval.vue"),
    },
    // Assessment Plans Routes
    {
        path: "/compliance/assessment-plans",
        name: "assessment-plans-list",
        meta: {title: "Assessment Plans", authRequired: true},
        component: () => import("../views/compliance-monitoring/AssessmentPlansList.vue"),
    },
    {
        path: "/compliance/assessment-plans/create",
        name: "create-assessment-plan",
        meta: {title: "Create Assessment Plan", authRequired: true},
        component: () => import("../views/compliance-monitoring/AssessmentPlanWizard.vue"),
    },
    {
        path: "/compliance/assessment-plans/:id/view",
        name: "view-assessment-plan",
        meta: {title: "Assessment Plan Details", authRequired: true},
        component: () => import("../views/compliance-monitoring/AssessmentPlanDetails.vue"),
    },
    {
        path: "/compliance/assessment-plans/:id/edit",
        name: "edit-assessment-plan",
        meta: {title: "Edit Assessment Plan", authRequired: true},
        component: () => import("../views/compliance-monitoring/AssessmentPlanWizard.vue"),
    },
    {
        path: "/compliance/assessment-plans/:id/amend",
        name: "amend-assessment-plan",
        meta: {title: "Amend Assessment Plan", authRequired: true},
        component: () => import("../views/compliance-monitoring/AssessmentPlanWizard.vue"),
    },
    // Team-leader workspace: My Assessment Plans
    {
        path: "/compliance/my-assessment-plans",
        name: "my-assessment-plans",
        meta: {title: "My Assessment Plans", authRequired: true},
        component: () => import("../views/compliance-monitoring/MyAssessmentPlans.vue"),
    },
    {
        path: "/compliance/my-assessment-plans/:id",
        name: "my-assessment-plan-details",
        meta: {title: "My Assessment Plan", authRequired: true},
        component: () => import("../views/compliance-monitoring/MyAssessmentPlanDetails.vue"),
    },
    // Secretary workspace: My Assessment Letters
    {
        path: "/compliance/my-assessment-letters",
        name: "my-assessment-letters",
        meta: {title: "My Assessment Letters", authRequired: true},
        component: () => import("../views/compliance-monitoring/MyAssessmentLetters.vue"),
    },
    {
        path: "/compliance/assessment-letters/:assessmentId/edit",
        name: "assessment-letter-editor",
        meta: {title: "Assessment Letter", authRequired: true},
        component: () => import("../views/compliance-monitoring/AssessmentLetterEditor.vue"),
    },
    // Assessment Letter Approval (workflow action_url route)
    {
        path: "/compliance/assessment-letters/approve",
        name: "compliance/assessment-letters/approve",
        meta: {title: "Assessment Letter Approval", authRequired: true},
        component: () => import("../views/compliance-monitoring/AssessmentLetterApproval.vue"),
    },
    // Assessment Report Approval (workflow action_url route — ACAR)
    {
        path: "/compliance/assessment-reports/approve",
        name: "compliance/assessment-reports/approve",
        meta: {title: "Assessment Report Approval", authRequired: true},
        component: () => import("../views/compliance-monitoring/AssessmentReportApproval.vue"),
    },
    // Prepare Execution (Phase 2) — team re-affirm + tender sampling + assignment
    {
        path: "/compliance/assessments/:assessmentId/prepare-execution",
        name: "prepare-execution",
        meta: {title: "Prepare Execution", authRequired: true},
        component: () => import("../views/compliance-monitoring/PrepareExecutionWizard.vue"),
    },
    // Finalize Report (Phase 4) — tool weights + score sheets
    {
        path: "/compliance/assessments/:assessmentId/finalize-report",
        name: "finalize-report",
        meta: {title: "Finalize Report", authRequired: true},
        component: () => import("../views/compliance-monitoring/FinalizeReportWizard.vue"),
    },
    // Finalised assessment report — view scores, edit narrative, download PDF
    {
        path: "/compliance/assessments/:assessmentId/report",
        name: "assessment-report",
        meta: {title: "Assessment Report", authRequired: true},
        component: () => import("../views/compliance-monitoring/AssessmentReportView.vue"),
    },
    // Team-leader review of the secretary's prepared report (before it enters the approval workflow)
    {
        path: "/compliance/assessments/:assessmentId/review-report",
        name: "team-leader-review-report",
        meta: {title: "Review Assessment Report", authRequired: true},
        component: () => import("../views/compliance-monitoring/TeamLeaderReviewReport.vue"),
    },
    // Assessment Execution Routes
    {
        path: "/compliance/assessment-plans/:planId/procuring-entities/:peId/setup-assessment",
        name: "setup-assessment",
        meta: {title: "Setup Assessment", authRequired: true},
        component: () => import("../views/compliance-monitoring/AssessmentSetupWizard.vue"),
    },
    {
        path: "/compliance/assessments/:id/execute",
        name: "execute-assessment",
        meta: {title: "Execute Assessment", authRequired: true},
        component: () => import("../views/compliance-monitoring/AssessmentExecutionSheet.vue"),
    },
    {
        path: "/compliance/my-assessment-tasks",
        name: "my-assessment-tasks",
        meta: {title: "My Assessment Tasks", authRequired: true},
        component: () => import("../views/compliance-monitoring/MyAssessmentTasks.vue"),
    },
    // Secretary workspace: procuring-entity (non-tender) assessment tools
    {
        path: "/compliance/my-pe-assessments",
        name: "my-pe-assessments",
        meta: {title: "PE Assessments", authRequired: true},
        component: () => import("../views/compliance-monitoring/MyPeAssessments.vue"),
    },
    // PE Assessment Details (view sample groups, execute assessments, finalize)
    {
        path: "/compliance/assessments/:assessmentId/details",
        name: "pe-assessment-details",
        meta: {title: "Assessment Details", authRequired: true},
        component: () => import("../views/compliance-monitoring/PEAssessmentDetails.vue"),
    },
    // PE Assessment Details for PENDING_SETUP (no assessment created yet)
    {
        path: "/compliance/assessment-plans/:planId/procuring-entities/:peId/details",
        name: "pe-assessment-pending",
        meta: {title: "PE Assessment Details", authRequired: true},
        component: () => import("../views/compliance-monitoring/PEAssessmentDetails.vue"),
    },
    // Old routes commented out - missing view files
    // {
    //     path: "/complianceMonitoring/new-assessment-plan",
    //     name: "new-assessment-plan",
    //     meta: {title: "Elibrary New Topic", authRequired: true},
    //     component: () => import("../views/complianceMonitoring/new-plan.vue"),
    // },
    // {
    //     path: "/complianceMonitoring/new-Review-And-Analysis",
    //     name: "new-review-and-analysis",
    //     meta: {title: "Compliance Monitoring New Review & Analysis", authRequired: true},
    //     component: () => import("../views/complianceMonitoring/new-Review-And-Analysis.vue"),
    // }
]
